import {
  fetchClient
} from "./chunk-SKVXOXWB.mjs";
import {
  ApiConfig
} from "./chunk-LPIRJEMY.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/hy/booking/download.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var downloadFile = (data, fileName) => {
  const blob = new Blob([data]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${fileName}.pdf`);
  document.body.appendChild(link);
  link.click();
};
var downloadTicketHY = (_0) => __async(void 0, [_0], function* ({ orderId, title, lang }) {
  var _a, _b;
  try {
    const lan = getLocaleOnly(lang);
    const response = yield fetchClient({
      url: `/payment/${orderId}/download-tickets?lang=${lan}&source=${(_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource}`,
      raw: true
    });
    if (!response.ok) {
      throw new Error("Failed to download");
    }
    const blob = yield response.blob();
    downloadFile(blob, title);
  } catch (error) {
    throw new Exception({
      error,
      name: "downloadTicketHYException"
    });
  }
});

export {
  downloadTicketHY
};
//# sourceMappingURL=chunk-46OLU47T.mjs.map